import React from 'react'
import {
  Box,
  useResponsiveDropdown,
  Dropdown,
  useModalContext,
} from '@sketch/components'
import SharingModal from '../../modals/SharingModal'
import { PartialShareModal } from '../../modals/PartialShareModal'
import {
  TriggerButton,
  DropdownItemStyled,
  DropdownHeader,
  DropdownItemDescription,
} from './PartialShareDropdown.styles'
import { ShareWithoutVersion } from '../../../versioning'

interface DropdownContentProps {
  share: ShareWithoutVersion
  hide: (trigger: string) => void
}

const DropdownContent = ({ share, hide }: DropdownContentProps) => {
  const { showModal } = useModalContext()

  return (
    <Box width={256}>
      <DropdownHeader>Share Document…</DropdownHeader>
      <DropdownItemStyled
        onClick={() => {
          showModal(SharingModal, {
            identifier: share.identifier,
            name: share.name,
          })
          hide('opened-modal')
        }}
      >
        Edit Permissions…
      </DropdownItemStyled>
      <Dropdown.Divider />
      <DropdownItemStyled
        onClick={() => {
          showModal(PartialShareModal, {
            share,
          })
          hide('opened-modal')
        }}
      >
        Share a Preview
        <DropdownItemDescription>
          Use previews to share only specific pages and prototypes.
        </DropdownItemDescription>
      </DropdownItemStyled>
    </Box>
  )
}

interface PartialShareDropdownProps {
  share: ShareWithoutVersion
}

export const PartialShareDropdown = ({ share }: PartialShareDropdownProps) => {
  const [content, buttonProps] = useResponsiveDropdown({
    dropdown: DropdownContent,
    dropdownProps: { share },
    placement: 'bottom-end',
  })

  return (
    <>
      <TriggerButton {...buttonProps} data-testid="partial-sharing-button">
        Share…
      </TriggerButton>
      {content}
    </>
  )
}
